import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {User} from '@app/core/models/user.model';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

export interface IUsersFilters {
	'filter[departments.id]'?: string | number;
	'filter[first_name]'?: string;
	'filter[email]'?: string;
	'filter[phone_number]'?: string | number;
}

@Injectable()
export class UserService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): User {
		if (!params) {
			return new User(this.tenantTZ, this.interService);
		}

		return new User(this.tenantTZ, this.interService).deserialize(params);
	}

	public getAvailableUser(): User {
		return this.fresh({
			id: 1,
			first_name: this.interService.translate.instant('USER.AVAILABLE'),
			last_name: this.interService.translate.instant('USER.SHIFT'),
		});
	}

	public getUsers(filters: IUsersFilters = {}, page_size: number = 200, page: number = 1, include_deactivated: boolean = false): Observable<User[]> {
		const data = {
			...filters,
			page_size,
			page,
		};
		if (include_deactivated) {
			data['include_deactivated'] = true;
		}

		return this.httpService.getJson<User[]>('users', data).pipe(
			map((res: any) => res.data.map(user => new User(this.tenantTZ, this.interService).deserialize(user)))
		);
	}
}
